// import NextQuestionButtonComponent from 'app_components/commons/nextQuestionButton/containers/nextQuestionButtonComponent'
import AlphabetNextService from 'app_services/letters/alphabetNextService'
import { store } from 'app_storage/redux-storage'
import parse from 'html-react-parser'
import React, { CSSProperties, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Store } from 'redux'

import '../questionMultipleChoiceMultipleAnswer.scss'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';

//@Import actions
// import { updateQuestionState } from 'app_events/resource/exercise/actions'
// import LabelComponent from 'app_components/modules/editor/components/LabelComponent/LabelComponent'
//@end


interface IQuestionMultipleChoiceMultipleAnswerLayoutProps {
  questionData: any
  attemptInformation: any
  defaultAnswer: string[] | null
  checkBoxesStatus: string[]
  className?: string
  style?: CSSProperties
  hideButtons?: boolean
  disabled?: boolean
  showCorrect?: boolean
  showMyResponse?: boolean
  validateMyResponse?: boolean
  showFeedback?: boolean
  handleChange: (unique: string) => void
  onNextQuestion: (data: any) => void
  handleSendOnChange: (answers: string[]) => any
}

const QuestionMultipleChoiceMultipleAnswerLayout: React.FC<IQuestionMultipleChoiceMultipleAnswerLayoutProps> = (props) => {
  const storeObject: Store = store
  const form = useForm()
  const { t } = useTranslation()
  const alphabetNextService: AlphabetNextService = new AlphabetNextService('ABCDEFGHIJKLMNOPQRSTUVWXYZ')

  useEffect(() => {
    // storeObject.dispatch(updateQuestionState({
    //   questionData: props.questionData,
    //   answer: props.checkBoxesStatus,
    //   type: 'multipleChoiceMultipleAnswer',
    // }))
    // @INFO Enviar el evento on change
    props.handleSendOnChange([...props.checkBoxesStatus])
  }, [props.checkBoxesStatus.length, props.questionData._id])

  useEffect(() => {
    return () => {
      // storeObject.dispatch(updateQuestionState({}))
    }
  }, [])

  const getClassesAnswer = (selected?: boolean, answer?: any) => {
    if(selected){
      return `answer ${props.showMyResponse ? 'my-answer' : ''} ${props.validateMyResponse ? (answer?.is_correct ? 'correct' : 'incorrect') : ''} ${props.showCorrect && answer?.is_correct ? 'correct' : '' }`
    }else{
      return `answer ${props.showCorrect && answer?.is_correct ? 'correct' : '' }`
    }
  }

  return (
    <div
      className={`question_multiple_choice_multiple_answer-component ${props.className}`}
      style={props.style}
    >
      {/* <div className='content'>{parse(props.questionData.content)}</div> */}
      <div className='answers-container form-check'>
        <form onSubmit={form.handleSubmit((data) => props.onNextQuestion(data))}>
          {props.questionData.answers.length > 0 &&
            props.questionData.answers.map((answer: any) => {
              return (
                <div
                  className={getClassesAnswer(props.checkBoxesStatus.includes(answer.unique), answer)}
                  key={answer._id}
                >
                  <input
                    className='form-check-input'
                    type='checkbox'
                    name='answer'
                    id={answer._id}
                    value={answer.unique}
                    checked={props.checkBoxesStatus.includes(answer.unique)}
                    onChange={() => props.handleChange(answer.unique)}
                    ref={form.register({ required: false })}
                    disabled={props.disabled}
                  />
                  <label htmlFor={answer._id} className='content-answer'>
                    <div className='radio'>
                      <div className='radio-fill'></div>
                    </div>
                    <p>{alphabetNextService.next()}.&nbsp;</p>
                    {parse(answer.content)}
                    {props.checkBoxesStatus.includes(answer.unique) ?
                      props.showCorrect || props.validateMyResponse ?
                      <p
                        className="text-status-response"
                      >
                        {props.showCorrect || props.validateMyResponse || props.showMyResponse ?
                          props.showMyResponse ?
                            'Tu respuesta'
                          :
                          answer?.is_correct ?
                            'Respuesta correcta':
                            'Respuesta incorrecta'
                        :''}
                      </p>:null
                    :
                      props.showCorrect ?
                      <p
                        className="text-status-response"
                      >
                        {answer?.is_correct ?
                          'Respuesta correcta':
                          'Respuesta incorrecta'
                        }
                      </p>:null
                    }
                  </label>
                  {props.checkBoxesStatus.includes(answer.unique) ?
                    props.showFeedback && answer.feedback ?
                    <div className="container-feedback">
                        <LabelComponent
                          style={{fontWeight: 700}}
                        >
                          Justificación:
                        </LabelComponent>
                        {parse(answer.feedback)}
                    </div>:null
                  :null}
                </div>
              )
            })}
            {/* {!props.hideButtons ?
              <NextQuestionButtonComponent />
            :null} */}
        </form>
      </div>
    </div>
  )
}

export default QuestionMultipleChoiceMultipleAnswerLayout
